
let _ = require('../_.js');

let $ = jQuery;

_.property_noun_item_singular = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "lot"
    }
    return property.item_singular;
}

_.property_noun_item_plural = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "tracts"
    }
    return property.item_plural;
}

_.property_noun_unit_singular = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "acre"
    }
    return property.unit_singular;
}

_.property_noun_unit_plural = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "acres"
    }
    return property.unit_plural;
}

_.property_noun_unit_plural_plusminus = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "acres ±"
    }
    return property.unit_plural + (property.unit_plural_shows_plusminus ? " ±" : "");
}

_.property_noun_unit_abbr_plusminus = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "ac ±"
    }
    return property.unit_abbr + (property.unit_plural_shows_plusminus ? " ±" : "");
}

_.property_noun_item_singular_ucwords = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "Lot"
    }
    return _.ucwords(property.item_singular);
}

_.property_noun_item_plural_ucwords = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "Tract"
    }
    return _.ucwords(property.item_plural);
}

_.property_noun_unit_singular_ucwords = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "Acre"
    }
    return _.ucwords(property.unit_singular);
}

_.property_noun_unit_plural_ucwords = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "Acres"
    }
    return _.ucwords(property.unit_plural);
}

_.property_noun_unit_plural_ucwords_plusminus = function (property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property) {
        return "Acres ±"
    }
    return _.ucwords(property.unit_plural) + (property.unit_plural_shows_plusminus ? " ±" : "");
}

_.represent_units_with_plusminus = function (count, property = null) {
    if (property === null && _.ac_state) {
        property = _.ac_state.property;
    }
    if (!property || property.unit_plural_shows_plusminus) {
        return (count * 1) + " ±";
    } else {
        return count;
    }
}


